/* Jakes Breaks – auto-slide featured product sections; respects motion preferences. */
(() => {
  'use strict';
  if (window.__jbFeaturedAutoRotateLoaded) return;
  window.__jbFeaturedAutoRotateLoaded = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialize() {
    document.querySelectorAll('slider-component[data-jb-auto-rotate="true"]').forEach((carousel) => {
      if (carousel.dataset.jbAutoSlideInitialized === 'true') return;
      carousel.dataset.jbAutoSlideInitialized = 'true';
      const track = carousel.querySelector('ul.slider');
      if (!track) return;

      const delay = Math.min(9000, Math.max(3000, (Number(carousel.dataset.jbAutoRotateSpeed) || 6) * 1000));
      let paused = false;

      function advance() {
        if (paused || document.hidden || reducedMotion.matches) return;
        const slides = track.querySelectorAll('li.slider__slide');
        if (slides.length < 2) return;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (maxScroll < 8) return;
        const step = Math.abs(slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left);
        if (step < 8) return;
        const next = track.scrollLeft >= maxScroll - 8 ? 0 : Math.min(maxScroll, track.scrollLeft + step);
        track.scrollTo({ left: next, behavior: 'smooth' });
      }

      carousel.addEventListener('mouseenter', () => { paused = true; });
      carousel.addEventListener('mouseleave', () => { paused = false; });
      carousel.addEventListener('focusin', () => { paused = true; });
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) paused = false;
      });
      carousel.addEventListener('touchstart', () => { paused = true; }, { passive: true });
      carousel.addEventListener('touchend', () => {
        window.setTimeout(() => { paused = false; }, delay);
      }, { passive: true });
      window.setInterval(advance, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
